import singleWordReducer from '../reducers/single-word-reducer';
import {
    RESET_GAME_ACTION,
    ADD_WORD_ACTION,
    REMOVE_WORD_ACTION,
    MARK_WORD_AS_FOUND_ACTION,
    MAX_LEVEL,
    WORDS_PER_LEVEL,
} from '../constants';
import data from '../data/words.json';

export const generateWordsState = (initialLevel) => {
    const params = new URLSearchParams(window.location.search);
    const words = params.get('words');
    let wordsList = [];
    if (words) {
        wordsList = words.split(',');
        params.set('words', null);
    } else {
        let level = initialLevel || parseInt(localStorage.getItem('level'), 10);
        if (isNaN(level) || level < 1 || level > MAX_LEVEL) {
            level = 1;
        }

        const shuffled = data.words.sort(() => 0.5 - Math.random());
        wordsList = shuffled.slice(0, level + WORDS_PER_LEVEL);
    }

    return wordsList.map((word) => ({
        text: word,
        isFound: false,
        color: 'black',
    }));
};

const initialState = generateWordsState();

const wordsReducer = (state = initialState, action) => {
    switch (action.type) {
        case RESET_GAME_ACTION:
            return generateWordsState();
        case ADD_WORD_ACTION:
            return [...state, singleWordReducer(state, action)];
        case REMOVE_WORD_ACTION:
            return [...state.slice(0, action.index), ...state.slice(action.index + 1)];
        case MARK_WORD_AS_FOUND_ACTION:
            return state.map((word) => {
                if (word.text === action.word) {
                    word = {...word, isFound: true, color: action.color};
                }
                return word;
            });
        default:
            return state;
    }
};

export default wordsReducer;
